import { useEffect, useState } from "react";
import { Flex, useBreakpointValue } from "@chakra-ui/react";

import DataTableSearch from "./DataTableSearch";
import DataTableTable from "./DataTableTable";
import DataTablePaginate from "./DataTablePaginate";
import DataTableCards from "./DataTableCards";

type IndicadorData = {
	id: string;
	nome: string;
	cid: string
	doc: string;
	phone: string;
	comissao: number;
}
interface DataTableIndicadoresParams {
	data: IndicadorData[];
	onRequestClose: (close: boolean) => void;
}

const DataTableIndicadores: React.FC<DataTableIndicadoresParams> = ({
	data,
	onRequestClose
}) => {
	const isWideVersion = useBreakpointValue({
		base: false,
		lg: true,
	});

	const [loading, setLoading] = useState(true);
	
	const [pesqClientes, setPesqClientes] = useState<IndicadorData[]>(data);
	const [clientes, setClientes] = useState<IndicadorData[]>(data.slice(0, 5));

	const [sort, setSort] = useState({ por: '', cres: true });

	const [controls, setControls] = useState({
		page: 1,
		perPage: 5,
		totalPage: Math.ceil(data.length / 5),
	});

	async function handleUpdateList(page: number, perPage: number, clients: IndicadorData[]) {
		const auxPage = page - 1;
		const start = auxPage * perPage;
		const end = start + perPage;

		setClientes(clients.slice(start, end));
	};

	useEffect(() => {
		setLoading(false);
	}, []);

	return (
		<Flex
			w="100%"
			flexDir="column"
		>
			<DataTableSearch
				clientes={data}
				setPesqClientes={setPesqClientes}
				controls={controls}
				setControls={setControls}
				handleUpdateList={handleUpdateList}
			/>

			{isWideVersion && (
				<DataTableTable
					clientes={clientes}
					pesqClientes={pesqClientes}
					sort={sort}
					setSort={setSort}
					controls={controls}
					handleUpdateList={handleUpdateList}
					onRequestClose={onRequestClose}
				/>
			)}
			
			{!isWideVersion && !loading &&(
				<DataTableCards clientes={clientes} onRequestClose={onRequestClose} />
			)
			}

			<DataTablePaginate
				cli_length={data.length}
				pesq_length={pesqClientes.length}
				pesqClientes={pesqClientes}
				controls={controls}
				setControls={setControls}
				handleUpdateList={handleUpdateList}
			/>
		</Flex>
	)
}

export default DataTableIndicadores;